<main class="container py-5">
  <section class="ticket-card bg-white p-4 p-md-5 text-center">
    <h1 class="h3 fw-bold mb-3">Validación de boleto</h1>

    <div *ngIf="loading" class="text-muted">
      Verificando información del QR...
    </div>

    <div *ngIf="!loading">
      <span class="badge fs-6 px-3 py-2" [class]="badgeClass">{{ statusLabel }}</span>

      <p class="mt-4 mb-1" *ngIf="serial">
        <strong>Serial:</strong> {{ serial }}
      </p>
      <p class="mb-0 text-muted" *ngIf="eventTitle">
        Evento: {{ eventTitle }}
      </p>
    </div>
  </section>
</main>
